<script setup lang="ts">
    import { ref, onMounted } from 'vue';
    import { getSurveyTypes, type AiDropdownOption } from '@cwd/AiTools/AiEditor.access';
    import FormSelectWithAddItem, { Item } from '@shared/components/Form/FormSelectWithAddItem.vue';

    const modelValue = defineModel<string>('state.prompt');
    const surveyTypeOptions = ref<Item[]>([]);
    const emit = defineEmits(['surveyTypeSelected']);

    const handleCustomOptionAdded = (newOption: Item) => {
        emit('surveyTypeSelected');
    };

    onMounted(() => {
        const surveyTypes = getSurveyTypes();

        surveyTypeOptions.value = [
            ...surveyTypes.map(
                (option: AiDropdownOption): Item => ({
                    label: option.Text,
                    value: option.Text,
                })
            ),
            { label: $Resources.AIAssistantCreateSurveyCustomTypeOption, value: 'custom-survey-type-value' },
        ];
    });
</script>

<template>
    <FormSelectWithAddItem
        v-model="modelValue"
        :label="$Resources.AIAssistantCreateSurveyTypeOptionTitle"
        required
        :infoText="$Resources.AIAssistantCreateSurveyTypeOptionHelpTextContent"
        :options="surveyTypeOptions"
        :placeholder="$Resources.AIAssistantCreateSurveyTypeOptionPlaceholder"
        :allowAdd="true"
        customOptionValue="custom-survey-type-value"
        :customInputPlaceholder="$Resources.AIAssistantCreateSurveyCustomTypePlaceholder"
        :addItemButtonText="$Resources.AIAssistantCreateSurveyCustomTypeAddButton"
        @customOptionAdded="handleCustomOptionAdded" />
</template>
